import {useAuthenticationContext} from '../contexts/authentication'

// ----------------------------------------------------------------------

const useAuth = () => {
    return useAuthenticationContext()
};

export default useAuth;
